import { useQuery } from '@tanstack/react-query'
import { finansApi, finansQueryKeys } from './api'
import { formatDateTime } from './format'

/**
 * Per-module "son kayıt" strip.
 *
 * Exists to correct a working belief: the owners assume Korgun is staler than
 * the advisor's weekly sheet, and the reconciliation (docs/finans-design.md)
 * showed the opposite on every module. Showing the entry timestamps
 * continuously is what earns the panel's numbers their trust.
 *
 * Wording is deliberate: "en son kayıt" — the newest recorded change. It is
 * NOT "veriler şu tarihe kadar günceldir": a max over business rows proves a
 * newest write, not completeness up to it.
 */
export function FreshnessStrip() {
  const { data, isPending, isError } = useQuery({
    queryKey: finansQueryKeys.tazelik(),
    queryFn: () => finansApi.tazelik(),
    // Keep the trust anchor current on a screen left open.
    refetchInterval: 15 * 60_000,
  })

  if (isError) return null
  if (isPending || !data) {
    return (
      <div aria-hidden className="h-7 animate-pulse rounded-xs bg-hairline/60" />
    )
  }

  return (
    <div className="flex flex-wrap items-baseline gap-x-4 gap-y-1 rounded-xs border border-hairline bg-surface px-3 py-1.5">
      <span className="eyebrow">Veri tazeliği</span>
      {data.modules.map((module) => (
        <span key={module.id} className="whitespace-nowrap text-micro text-ink-muted">
          {module.label}{' '}
          <span className="font-mono tnum text-ink">{formatDateTime(module.lastEntry)}</span>
        </span>
      ))}
      {data.latestActivityAt ? (
        <span className="ml-auto whitespace-nowrap text-micro text-ink-muted">
          Korgun&apos;daki en son kayıt:{' '}
          <span className="font-mono tnum font-medium text-ink">
            {formatDateTime(data.latestActivityAt)}
          </span>
        </span>
      ) : null}
    </div>
  )
}
